import React, { useState, useEffect } from 'react';

import ModalWarn from '../../Components/Modal/Warn/index'
import UnitElement from '../../Components/UnitElement'
import { estados } from '../../constants'
import { removeInputMask, cpfMask } from '../../utils'

export default function EditUnit(props) {
    const [ unit, setUnit ] = useState({
        organCode: '',
        unitCode: '',
        unitName: '',
        state: '',
        street: '',
        number: '',
        municipalityCode: '',
        neighborhood: '',
        addressComplement: '',
        enableCitizenOrAttorneyFingerprintVerify: false,
        enableAuthorizedCertificateLoginOnly: false,
        mobileServiceUnit: false,
        unitOpeningHoursDescription: '',
    });
    const [modalInvalidSessionError, setModalInvalidSessionError] = useState(false)
    const [modalInvalidSessionErrorTitle, setModalInvalidSessionErrorTitle] = useState(null)
    const [modalInvalidSessionErrorMsg, setModalInvalidSessionErrorMsg] = useState(null)
    const [userList, setUserList ] = useState([]);
    const [rangePages, setRangePages ] = useState({
        label: "10", value: "10"
    });
    const [pageOptions, setPageOptions ] = useState([]);
    const [page, setPage ] = useState({
        label: "1", value: "1"
    });
    const [totalFilter, setTotalFilter ] = useState(0);

    
    const [userListAttendant, setUserListAttendant ] = useState([]);
    const [rangePagesAttendant, setRangePagesAttendant ] = useState({
        label: "10", value: "10"
    });
    const [pageOptionsAttendant, setPageOptionsAttendant ] = useState([]);
    const [pageAttendant, setPageAttendant ] = useState({
        label: "1", value: "1"
    });
    const [totalFilterAttendant, setTotalFilterAttendant ] = useState(0);
    const [successMsg, setSuccessMsg] = useState();
    const [firstTime, setFirstTime] = useState(true);
    const opcoesPesquisaCEP = {
        PREENCHER_FORMULARIO: 'PREENCHER_FORMULARIO',
        NAO_PREENCHER_FORMULARIO: 'NAO_PREENCHER_FORMULARIO'
    }
    
    function handleEraseMsg (event) {
        if (event.target.matches('input, button')) {
            setSuccessMsg(undefined);
            document.removeEventListener('click', handleEraseMsg); //Remove o listener para não consumir recurso.
          }
    }

    useEffect(() => {   
        if (props.location.state !== undefined) {
            if ((props.location.state?.unit !== undefined) && (props.location.state?.userlist !== undefined)) {  //Carrega as informações de edição da unidade antes do clique no botão "Cadastrar Gestor Regional"
                setUnit(props.location.state.unit);
                setUserList(props.location.state.userlist);
                const msg = sessionStorage.getItem('successMsg');
                sessionStorage.removeItem('successMsg');
                setSuccessMsg(msg);
                if (msg) {  //Adiciona o CPF do gestor que acabou de ser inserido. Apaga a mensagem de sucesso após algum clique em um input box ou button
                    document.getElementById("cpf-input").value = cpfMask(props.location.state?.cpf); 
                    document.getElementById("cpf-input").dispatchEvent(new Event('input', { bubbles: true }));
                    setTimeout(() => { document.getElementById('bntIncluirVincular').click(); }, 50); //deixa o click() para o final da fila de execução — o que garante que o input e qualquer onInput ou onChange associado tenham sido processados.
                    setTimeout(() => { document.addEventListener('click', handleEraseMsg); }, 50);                     
                }       
            } else {
                    setUnit({
                        organCode: props.location.state.result_search.CODIGO_ORGAO,
                        unitCode: props.location.state.result_search.CODIGO_UNIDADE,
                        unitName: props.location.state.result_search.NOME_UNIDADE,
                        state: estados.filter(option => option.value === props.location.state.result_search.ESTADO)[0],
                        street: props.location.state.result_search.LOGRADOURO,
                        number: props.location.state.result_search.NUMERO,
                        municipalityCode: props.location.state.result_search.CODIGO_MUNICIPIO,
                        neighborhood: props.location.state.result_search.BAIRRO,
                        addressComplement: props.location.state.result_search.COMPLEMENTO,
                        zipcode: props.location.state.result_search.CEP,
                        enableCitizenOrAttorneyFingerprintVerify: (props.location.state.result_search.HABILITA_BIOMETRIA_CIDADAO === 'S' ? true : false),
                        enableAuthorizedCertificateLoginOnly: (props.location.state.result_search.LOGIN_APENAS_POR_CERT_AUTORI === 'S' ? true : false),
                        mobileServiceUnit: (props.location.state.result_search.ATENDIMENTO_MOVEL === 'S' ? true : false),
                        unitOpeningHoursDescription: props.location.state.result_search.DESCRICAO_HORARIO
                    });
                    onChangePaginationConfig(rangePages, null, true)
            }
            onChangePaginationConfigAttendant(rangePagesAttendant, null, true)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (unit.zipcode && firstTime) {
            pesquisaCEP(unit.zipcode, opcoesPesquisaCEP.NAO_PREENCHER_FORMULARIO); //Necessário para verificar se o CEP cadastrado previamente existe. De acordo com a regra anterior, quando o CEP não era encontrado na base de dados dos Correios, o sistema liberava o cadastro de qualquer endereço. 
            setFirstTime(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [unit.zipcode]);

    const [ loadingEdit, setLoadingEdit ] = useState(false);
    const [ modalError, setModalError ] = useState(false);
    const [ messageError, setMessageError ] = useState("");
    const [ loadingIncludeGestor, setLoadingIncludeGestor ] = useState(false);

    const onSubmitUnitData = async (data) => {
        
        setLoadingEdit(true);

        const requestOptions = {
            method: 'PUT',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "", //Neste caso, o cpf_atendente se refere ao gestor que está cadastrando (que está atendendo)
                codigo_orgao: data.organCode,
                codigo_unidade: data.unitCode,
                nome_unidade: data.unitName,                
                cep: data.zipcode,
                estado: data.state,
                codigo_municipio: data.municipalityCode,
                logradouro: data.street,
                numero: data.number,
                complemento: data.addressComplement,
                bairro: data.neighborhood,
                gestores_regionais: userList,
                atendentes: userListAttendant,
                habilita_biometria_cidadao_procurador: data.enableCitizenOrAttorneyFingerprintVerify,
                enable_authorized_certificate_loginOnly: data.enableAuthorizedCertificateLoginOnly,
                mobile_service_unit: data.mobileServiceUnit,
                descricao_horario: data.unitOpeningHoursDescription
            }),
        };
        
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/unidade/editaUnidadeOrgao`, requestOptions).then(
            function(response) {
            if (response.ok) {
                response.json().then(function(data_request) {
                    const unit_edited = {
                        message: data_request.message
                    }
                    setLoadingEdit(false);
                    
                    //console.log(unit_aEditd);
                    props.history.push('gerenciarUnidades', unit_edited);
                });
            } else if (response.status === 422) {
                response.json().then(function(data) {
                    data.message = data.messages ? data.messages[0].message : data.message
                    if (!!data.errorCode && !!data.message) {
                        // inserir a mensagem: data.message no aviso de erro
                        setMessageError(data.message);
                        setModalError(true);
                    } else {
                        // inserir mensagem genérica
                        setMessageError('Houve algum problema no servidor.');
                        setModalError(true);
                    }

                    setLoadingEdit(false);
                });
            } else if (response.status === 403) {
                response.json().then(function (data) {
                  setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                  setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                  setLoadingEdit(false)
                  setModalInvalidSessionError(true)
                })
            } else {
                setMessageError('Houve algum problema no servidor. Aguarde um momento e tente novamente.');
                setModalError(true);
                setLoadingEdit(false);
            }
        }).catch(function(err) {
            console.error('Failed retrieving information', err);
        });
    }

    const pesquisaCEP = async (cep, opcoes) => {
        cep = cep.replace(/\D/g, '')

        setLoadingEdit(true);

        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "", //Neste caso, o cpf_atendente se refere ao gestor que está cadastrando (que está atendendo)
                cep: cep
            }),
        };
         
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/unidade/pesquisaCEP`, requestOptions).then(
            function(response) {
            if (response.ok) {
                response.json().then(function(data) {
                    if (opcoes !== opcoesPesquisaCEP.NAO_PREENCHER_FORMULARIO) {
                        setUnit( {...unit, zipcode: data.zipcode, state: estados.filter(option => option.value === data.state)[0], municipalityCode: data.municipalityCode, street: data.street, addressComplement: data.addressComplement, neighborhood: data.neighborhood, number: ''})
                    }
                    setLoadingEdit(false);
                });
            } else if (response.status === 422) {
                response.json().then(function(data) {
                    data.message = data.messages ? data.messages[0].message : data.message
                    if (!!data.errorCode && !!data.message) {
                        // inserir a mensagem: data.message no aviso de erro
                        setMessageError(data.message);
                        setModalError(true);
                    } else {
                        // inserir mensagem genérica
                        setMessageError('Houve algum problema no servidor.');
                        setModalError(true);
                        console.log('Response error in /gestao/unidade/pesquisaCEP BackendBalcao');
                    }

                    setLoadingEdit(false);
                });
            } else if (response.status === 403) {
                response.json().then(function (data) {
                  setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                  setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                  setLoadingEdit(false)
                  setModalInvalidSessionError(true)
                })
            } else {
                setMessageError('Houve algum problema no servidor. Aguarde um momento e tente novamente.');
                setModalError(true);
                setLoadingEdit(false);
            }
        }).catch(function(err) {
            console.error('Failed retrieving information', err);
        });
    }

    const onSubmitCPF = async(cpf) => {
        cpf = removeInputMask(cpf);
        setModalError(false);
        setLoadingEdit(true);
        setLoadingIncludeGestor(true);
        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "",  //Neste caso, o cpf_atendente se refere ao gestor que está cadastrando (que está atendendo)
                cpf_gestor_regional: cpf,
                codigo_orgao: unit.organCode,
                codigo_unidade: unit.unitCode
            }),
        };
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/unidade/consultaGestorRegionalAVincularUnidade`, requestOptions).then(
            function(response) {
                if (response.ok) {
                    response.json().then(function(data) {
                        let users = userList;
                        users.unshift(data);
                        setUserList(users);
                        setTotalFilter(parseInt(totalFilter) + 1);
                        setLoadingEdit(false);
                        setLoadingIncludeGestor(false)
                    });
                } else if (response.status === 422) {
                    response.json().then(function(data) {
                        if (!!data.errorCode && !!data.message) {
                            // inserir a mensagem: data.message no aviso de erro
                            setModalError(true);
                            setMessageError(data.message);
                        } else {
                            // inserir mensagem genérica
                            setModalError(true);
                            setMessageError('Houve algum problema no servidor.');
                        }
    
                        setLoadingEdit(false);
                        setLoadingIncludeGestor(false)
                    });
                } else if (response.status === 403) {
                    response.json().then(function (data) {
                      setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                      setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                      setLoadingEdit(false)
                      setLoadingIncludeGestor(false)
                      setModalInvalidSessionError(true)
                    })
                } else {
                    setMessageError('Houve algum problema no servidor. Aguarde um momento e tente novamente.');
                    setModalError(true);
                    setLoadingEdit(false);
                    setLoadingIncludeGestor(false)
                }
            }
        ).catch(function(err) {
            console.error('Failed retrieving information', err);
        });
    }


    const onChangePaginationConfig = async (ranPag, pag, isRanPag) => {
        setMessageError(undefined);

        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "",  //Neste caso, o cpf_atendente se refere ao gestor que está cadastrando (que está atendendo)
                codigo_unidade: props.location.state?.result_search?.CODIGO_UNIDADE || props.location.state?.unit.unitCode,
                pagina_atual: isRanPag ? "1" : pag.value,
                qtd_registros: ranPag.value
            }),
        };
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/unidade/listaGestoresRegionaisAssociadosAUnidade`,
                    requestOptions
            ).then(function(response) {
                if (response.ok) {
                    response.json().then(function(data) {
                        const maxPageOption = Math.ceil(Number(data.total) / Number(ranPag.value))
                        let list = []
                        let obj = {}
                        for(var i = 1; i <= maxPageOption; i++) {
                            obj = {
                                value: String(i),
                                label: String(i)
                            }

                            list.push(obj);
                        }

                        setPageOptions(list);
                        if(isRanPag){
                            setPage({label: "1", value: "1"});
                        }
                        setUserList(data.usuarios);
                        setTotalFilter(data.total);
                    });
                } else if (response.status === 422) {
                    response.json().then(function(data) {
                        if (!!data.errorCode && !!data.message) {
                            setModalError(data.message)
                            setMessageError(data.message)
                        } else {
                            setMessageError('Houve algum problema no servidor.');
                        }
                        //setLoading(false);
                    });
                } else if (response.status === 403) {
                    response.json().then(function (data) {
                    setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                    setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                    setModalInvalidSessionError(true)
                    })
                } else {
                    // FALHOU AO CONSUMIR O BACKEND DO BALCAO !!!!
                    //setLoading(false);
                    console.log('Request error in gestao/listaGestoresRegionaisAssociadosAUnidade BackendBalcao');
                }
            }).catch(function(err) {
                console.error('Failed retrieving information', err);
            });
    };






    
    const onChangePaginationConfigAttendant = async (ranPag, pag, isRanPag) => {
        setMessageError(undefined);

        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "",  //Neste caso, o cpf_atendente se refere ao gestor que está cadastrando (que está atendendo)
                codigo_unidade: props.location.state?.result_search?.CODIGO_UNIDADE || props.location.state?.unit.unitCode,
                pagina_atual: isRanPag ? "1" : pag.value,
                qtd_registros: ranPag.value
            }),
        };
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/unidade/listaAtendentesAssociadosAUnidade`,
                    requestOptions
            ).then(function(response) {
                if (response.ok) {
                    response.json().then(function(data) {
                        const maxPageOption = Math.ceil(Number(data.total) / Number(ranPag.value))
                        let list = []
                        let obj = {}
                        for(var i = 1; i <= maxPageOption; i++) {
                            obj = {
                                value: String(i),
                                label: String(i)
                            }

                            list.push(obj);
                        }

                        setPageOptionsAttendant(list);
                        if(isRanPag){
                            setPageAttendant({label: "1", value: "1"});
                        }
                        setUserListAttendant(data.usuarios);
                        setTotalFilterAttendant(data.total);
                    });
                } else if (response.status === 422) {
                    response.json().then(function(data) {
                        if (!!data.errorCode && !!data.message) {
                            setModalError(data.message)
                            setMessageError(data.message)
                        } else {
                            setMessageError('Houve algum problema no servidor.');
                        }
                        //setLoading(false);
                    });
                } else if (response.status === 403) {
                    response.json().then(function (data) {
                    setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                    setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                    setModalInvalidSessionError(true)
                    })
                } else {
                    // FALHOU AO CONSUMIR O BACKEND DO BALCAO !!!!
                    //setLoading(false);
                    console.log('Request error in gestao/listaAtendentesAssociadosAUnidade BackendBalcao');
                }
            }).catch(function(err) {
                console.error('Failed retrieving information', err);
            });
    };

    return (
        <>
            <ModalWarn
                id='modalWarnalertInvalidSession'
                appear={modalInvalidSessionError}
                title = { modalInvalidSessionErrorTitle }
                text={ modalInvalidSessionErrorMsg ? modalInvalidSessionErrorMsg : 'Este acesso foi transferido para outro dispositivo.'}
                textButton2='Ir para tela inicial'
                actionButton2={() => { 
                    document.getElementById("btnLogout").click();
                }}
            />
            <UnitElement
                pageTitle='Editar unidade'
                onSubmitData={onSubmitUnitData}
                pesquisaCEP={pesquisaCEP}
                unit={unit}
                setUnit={setUnit}
                stateOptions={estados}
                loadingAdd={loadingEdit}
                setLoading={setLoadingEdit}
                modalError ={modalError}
                setModalError={setModalError}
                setMessageError={setMessageError}
                messageError={messageError}
                buttonCancelRoute='/gerenciarUnidades'
                buttonRegistrationRoute='/consultaGestorRegional'
                returnTo='editunit'
                history={props.history}
                location={props.location}

                onChangePaginationConfig={onChangePaginationConfig}
                onSubmitCPF={onSubmitCPF}
                setLoadingIncludeGestor={setLoadingIncludeGestor}
                loadingIncludeGestor={loadingIncludeGestor}
                searchResult={userList}
                setSearchResult={setUserList}
                totalFilter={totalFilter}
                pageOptions={pageOptions}
                setPage={setPage}
                page={page}
                rangePages={rangePages}
                setRangePages={setRangePages}

                onChangePaginationConfigAttendant={onChangePaginationConfigAttendant}
                searchResultAttendant={userListAttendant}
                setSearchResultAttendant={setUserListAttendant}
                totalFilterAttendant={totalFilterAttendant}
                pageOptionsAttendant={pageOptionsAttendant}
                setPageAttendant={setPageAttendant}
                pageAttendant={pageAttendant}
                rangePagesAttendant={rangePagesAttendant}
                setRangePagesAttendant={setRangePagesAttendant}
                fromSuccessMsg={successMsg}
            />
        </>
    );
}